import { InputWithLabel } from '@adotel/components'
import Typography from '@material-ui/core/Typography'

import { getTranslate } from '../../../../localization'
import { SessionConfiguration } from '../../../../types/iamSessions'
import useStyles from './index.styles'

type Props = {
  updateSessionConfigInput: SessionConfiguration
  setUpdateSessionConfigInput: React.Dispatch<
    React.SetStateAction<SessionConfiguration>
  >
}
const AccountLockout = ({
  updateSessionConfigInput,
  setUpdateSessionConfigInput
}: Props) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Typography variant="h4" className={classes.header}>
        {getTranslate('Account Lockout Configuration')}
      </Typography>
      <Typography variant="h5" className={classes.subTitle}>
        {getTranslate('Configure Lockout Duration and Attempts')}
      </Typography>
      <div className={classes.main}>
        <InputWithLabel
          label={getTranslate('Account Lockout Duration (Minutes)')}
          helpertext={getTranslate('Duration of Lockout')}
          value={updateSessionConfigInput.lockDurationMinutes}
          onChange={(event) => {
            const value = event.currentTarget.value
            if (!/^\d*$/.test(value)) return
            setUpdateSessionConfigInput({
              ...updateSessionConfigInput,
              lockDurationMinutes: Number(value)
            })
          }}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          inputSize={'small'}
          className={classes.input}
        />
        <InputWithLabel
          label={getTranslate('Permenent Lockout Ater Attempts')}
          helpertext={getTranslate(
            'After this number of unsuccessful login attempts, account locks forever'
          )}
          value={updateSessionConfigInput.permenetLockAterAttempts}
          onChange={(event) => {
            const value = event.currentTarget.value
            if (!/^\d*$/.test(value)) return
            setUpdateSessionConfigInput({
              ...updateSessionConfigInput,
              permenetLockAterAttempts: Number(value)
            })
          }}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          inputSize={'small'}
          className={classes.input}
        />
      </div>
    </div>
  )
}

export default AccountLockout
